module.exports = __webpack_public_path__ + "img/74.01c9fe24.png";